import React from 'react';
import {Link} from "react-router-dom";
import {PageWrapper} from "../../../../components/UI/PageWrapper/PageWrapper";
import styled from "styled-components";
import {ProfileUser} from "../Profile/components/ProfileUser/ProfileUser";
import {ProfileCompany} from "../Profile/components/ProfileCompany/ProfileCompany";
import {ProfilePersonnel} from "../Profile/components/ProfilePersonnel/ProfilePersonnel";
import {PhoneSettingsSection} from "./components/PhoneSettingsSection";
import {useAppSelector, useAppDispatch} from "../../../../store/store";
import {groupUserAdmin} from "../../../../config/acl/roles/groups";
import {mediaScreenSizes} from "../../../../utils/constans/styles/screenSizes";
import {isInAppWebView} from "../../../../utils/constants/mobileAppAuth";
import {FormattedMessage} from "react-intl";
import {LogoutOutlined, RightOutlined} from "@ant-design/icons";
import {logout} from "../../../../store/reducers/authReducer/authReducer";
import {pathFromRoute} from "../../../../utils/helpers/acl/pathFromRoute";
import {useIsMobile} from "../../../../hooks/useWindowSize";
import {useSettingsQuickLinks} from "./hooks/useSettingsQuickLinks";

const CompanyAndUserWrapper = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 20px;
  width: 95%;

  @media(max-width: ${mediaScreenSizes.tablet}) {
    width: 100%;
    flex-direction: row;
    column-gap: 16px;
  }
  
  @media(max-width: ${mediaScreenSizes.mobile}) {
    width: 100%;
    flex-direction: column;
    row-gap: 16px;
  }
`;

const QuickLinksSection = styled.section`
  margin-top: 24px;
  width: 95%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  @media(max-width: ${mediaScreenSizes.mobile}) {
    width: 100%;
  }
`;

const QuickLinkButton = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 16px 20px;
  border-radius: 10px;
  background: #e6f4ff;
  border: 1px solid #91caff;
  color: #1677ff;
  text-decoration: none;
  font-weight: 600;
  font-size: 15px;
  transition: background 0.2s, border-color 0.2s, color 0.2s;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  .anticon {
    color: #1677ff;
  }
  &:hover {
    background: #bae0ff;
    border-color: #69b1ff;
    color: #0958d9;
    .anticon {
      color: #0958d9;
    }
  }
`;

const LogoutSection = styled.section`
  margin-top: 24px;
  width: 95%;
  @media(max-width: ${mediaScreenSizes.mobile}) {
    width: 100%;
  }
`;

const LogoutButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 16px;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #ffccc7;
  color: #cf1322;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s;
  .anticon {
    color: #cf1322;
  }
  &:hover {
    background: #fff2f0;
    border-color: #ffa39e;
  }
`;

export const SettingsPage = () => {
  const {role} = useAppSelector(state => state.user.oneItemObject.item);
  const dispatch = useAppDispatch();
  const isMobile = useIsMobile();
  const quickLinks = useSettingsQuickLinks();

  return (
    <PageWrapper>
      <CompanyAndUserWrapper>
        <ProfileCompany />
        <ProfileUser />
      </CompanyAndUserWrapper>
      {isInAppWebView() && <PhoneSettingsSection />}
      {groupUserAdmin.includes(role) && <ProfilePersonnel />}
      {isMobile && quickLinks.length > 0 && (
        <QuickLinksSection>
          {quickLinks.map(link => (
            <QuickLinkButton key={link.route} to={pathFromRoute(link.route)}>
              <span style={{display: "flex", alignItems: "center", gap: 10}}>
                {link.icon}
                <FormattedMessage id={link.messageId} defaultMessage={link.defaultMessage}/>
              </span>
              <RightOutlined/>
            </QuickLinkButton>
          ))}
        </QuickLinksSection>
      )}
      <LogoutSection>
        <LogoutButton type="button" onClick={() => dispatch(logout())}>
          <FormattedMessage id="logout.title" defaultMessage="Log out" />
          <LogoutOutlined />
        </LogoutButton>
      </LogoutSection>
    </PageWrapper>
  );
};

